<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light m-0">
    <!-- Alert message -->
    <div>
      <v-alert :type="alert_type" :model-value="alert" :icon="alert_type === 'error' ? 'mdi-alert' : `$${alert_type}`" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <loading v-model:active="isFullpageLoading" 
      :can-cancel="true" 
      :is-full-page="fullPage" :color="primary_code">
    </loading>
    <!-- Header component -->
    <div>
      <HeaderComponent :headerTitle="headerText" />
    </div>

    <!-- Tabs -->
    <v-card class="v-card-100 mt-0">
      <v-tabs color="primary" v-model = "tab_index">
        <v-tab ripple style="text-transform:none!important;" @click="loadData(tab, 'tab_clicked')" class="tab-color"
          v-for="(tab, index) in tabs" :key="index">{{ tab }}</v-tab>
      </v-tabs>
    </v-card>

    <v-card-title style="padding: 25px 25px 15px 15px;"  class="action-style">
      <!-- Search fields -->
      <v-row>
          <v-col cols="12" md="4" sm="12" lg="4" xl="3" class="d-flex align-center pb-0">
            <v-combobox class="text-left mr-4" v-model="select_field" item-title="name" item-value="id" :items="select_field_items" label="Select Field" variant="outlined" style="max-width: 158px;"> </v-combobox>
            <v-text-field color="primary" prepend-inner-icon="mdi-magnify" :disabled="!select_field" v-model="pending_info_search" v-no-edge-space label="Search"
              style="max-width: 300px;" variant="outlined" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
          </v-col>
          <v-col cols="12"  md="8" sm="12" lg="8" xl="9" class="pb-0">
            <v-row>
              <v-spacer></v-spacer>
                <!-- Actions buttons -->
                <v-card-actions style="margin-bottom: 10px;">
                  <!-- :disabled="(this.selected.length == 0)" -->
                  <v-btn class="ma-2 text-none" size="x-large" variant="flat" color="primary" 
                  v-if="(active_tab !== 'Pending Disposition' && active_tab !== 'Pending For Approval') && (isActionAllowed(role) || ((active_tab == 'Pending Information' || active_tab == 'Pending Inspection' || active_tab == 'Pending BCL Tickets' || active_tab == 'Pending Decision') && role == 'warehouse_manager'))" 
                  @click="dialogOpen" :disabled="!isButtonEnabled">Update</v-btn>
                  <v-btn class="ma-2 text-none" size="x-large" variant="flat" color="primary" 
                  v-if="(active_tab !== 'Pending Disposition' && active_tab !== 'Pending For Approval') && (isActionAllowed(role) || ((active_tab == 'Pending Information' || active_tab == 'Pending Inspection' || active_tab == 'Pending BCL Tickets' || active_tab == 'Pending Decision') && role == 'warehouse_manager'))" 
                  @click="downloadInventory">Download</v-btn>
                  <v-btn class="ma-2 text-none" size="x-large" variant="flat" color="primary"
                   v-if="(active_tab !== 'Pending Disposition' && active_tab !== 'Pending For Approval') && (isActionAllowed(role) || ((active_tab == 'Pending Information' || active_tab == 'Pending Inspection' || active_tab == 'Pending BCL Tickets' || active_tab == 'Pending Decision') && role == 'warehouse_manager'))" 
                  @click="navigateToFileUpload">Upload</v-btn>

                  <template v-if="active_tab === 'Pending Disposition'  && isActionAllowed(role)">
                    <template v-if="this.currentUser.roles.includes('central_admin')  && isActionAllowed(role)">
                      <v-btn class="ma-2 text-none" size="x-large" variant="flat" :color="this.selected.length == 0 ? 'grey' : 'success'" :disabled="(this.selected.length == 0)"
                        @click="handleDisposition('approve')">Approve</v-btn>
                      <v-btn class="ma-2 text-none" size="x-large" variant="flat" :color="this.selected.length == 0 ? 'grey' : 'primary'" :disabled="(this.selected.length == 0)"
                        @click="handleDisposition('reject')">Reject</v-btn>
                    </template>
                    <div class="text-center" v-if="this.currentUser.roles.includes('default_user')  && isActionAllowed(role)">
                      <v-menu offset-y>
                        <template v-slot:activator="{ props }">
                          <v-btn :color="selected.length==0? '' : 'primary'" variant="flat" class="text-none" size="x-large" v-bind="props" :disabled="selected.length==0">
                            Assign Dispositions
                            <v-icon :color="selected.length==0? 'grey' : 'white'" dark>
                              mdi-menu-down
                            </v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item v-for="(item, index) in disposition_item"
                            @click="handleDisposition('assignDisposition', item)" :key="index">
                            <v-list-item-title>{{ item.code }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </template>

                </v-card-actions>
                <v-expansion-panels v-if="active_tab !== 'Pending For Approval'" class="custom-control_outlined ma-2" ref="filterPopupRef" readonly
                  style="max-width: 300px; margin-top: 12px !important; min-height: 52px;">
                  <v-expansion-panel variant="outlined" @click="filtersData" style="height: 56px;">
                    <v-expansion-panel-title>Filter
                    </v-expansion-panel-title>
                  </v-expansion-panel>
                </v-expansion-panels>
                <!-- Filter -->
            </v-row>
          </v-col>
      </v-row>
    </v-card-title>
    <v-layout column >
      <v-col cols="12" style="overflow: auto" class="p-0">
        <v-data-table hover 
            density="compact" 
            :search="search" 
            v-model="selected" 
            show-select 
            disable-pagination
            :hide-default-footer="true" 
            :headers="headers" 
            :items="table_data" 
            :loading="loading"
            fixed-header
            height="100%"
            :items-per-page="pageSize"
            loading-text="Loading Data... Please wait" 
            class="elevation-1"
            return-object
            :style="dataTableStyle"
            >
            <template #[`header.disposition_age`]="{ column }">
              <span>{{ column.title }}
                <AgeingTooltip />
              </span>
            </template>
            <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers" :key="header.key">
              <span v-if="header.key == 'tag_number'">
                <a href="#" @click.prevent="itemDetailpopup(item)" style="color: #1976d2 !important; cursor: pointer !important;"><u>{{ item.tag_number }}</u></a>
              </span> 
              <span v-else-if="header.key !== 'tag_number' && item[header.key]">
                <span v-tooltip="item[header.key]">
                  {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                </span>
              </span>
              <span v-else>-</span>
            </template>
            <!-- <template #[`item.tag_number`]="{ item }">
              <a @click="itemDetailpopup(item)" style="color: #1976d2;" class="cursor-pointer">
                <u>{{ item.tag_number }}</u>
              </a>
            </template> -->
            <!-- <template #[`item.benchmark_price`]="{ item }">
              <span>{{ (item.benchmark_price || item.benchmark_price == 0) ? item.benchmark_price.toLocaleString('en-IN') : '-' }}</span>
            </template>
            <template #[`item.net_recovery`]="{ item }">
              <span>{{ (item.net_recovery || item.net_recovery == 0) ? item.net_recovery.toLocaleString('en-IN') : '' }}</span>
            </template> -->
            <!-- <template #[`item.type_of_item`]="{ item }">
              <span>{{ item.type_of_item ? item.type_of_item : '-' }}</span>
            </template>
            <template #[`item.supplier`]="{ item }">
              <span>{{ item.supplier ? item.supplier : '-' }}</span>
            </template> -->
            <!-- <template #[`item.recovery_percent`]="{ item }">
              <span>{{ (item.recovery_percent || item.recovery_percent == 0) ? item.recovery_percent : '-' }}</span>
            </template> -->
            <!-- <template #[`item.remarks`]="{ item }">
              <span>{{ item.remarks ? item.remarks : '-' }}</span>
            </template>
            <template #[`item.serial_number`]="{ item }">
              <span>{{ item.serial_number ? item.serial_number : '-' }}</span>
            </template>
            <template #[`item.sub_location_name`]="{ item }">
              <span>{{ item.sub_location_name ? item.sub_location_name : '-' }}</span>
            </template> -->
          <template #bottom></template>
        </v-data-table>
      </v-col>
    </v-layout>

    <!-- pagination -->
             <div>
                <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-3"
                />
            </div>

    <!--update's dialogs -->
    <v-row justify="center">
    <BrandCallLogDialog :dialogDetails="dialogDetails" :rows="rows" :addMoreRows="addMoreRows" :addColoumns="addColoumns"
      :handleClosePopup="handleClosePopup" :handleSubmit="handleSubmit" :handlePopupLinkClick="handlePopupLinkClick"
      :disabledSubmitButton="disabledSubmitButton">
    </BrandCallLogDialog>
  </v-row>
  </v-card>
</template>

<script>
import HeaderComponent from '../../../../commoncomponents/HeaderComponent.vue';
import { required } from 'vuelidate/lib/validators';
import BrandCallLogDialog from "./BrandCallLogDialog.vue";
import Loading from 'vue-loading-overlay';
import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
// import { moduleAccessFunc,module_that_allowed,signout } from '@/backend/axios/moduleAccess';
import { moduleAccessFunc,module_that_allowed,signout,isOnlyViewAction } from '@/backend/axios/moduleAccess'

// import 'vue-loading-overlay/dist/vue-loading.css';
export default {

  data() {
    return {
      headerText: "",
      infoDataType: [],
      file: '',
      binaryData: '',
      alert_type: 'info',
      alert_message: '',
      loading: false,
      isFullpageLoading : false,
      primary_code: "#0275d8",
      fullPage : true,
      role:'',
      alert: false,
      active_tab: "Pending Information",
      files: [],
      selected_item: {},
      selected: [],
      putaway_process:'',
      tabs: [
        "Pending Information",
        "Pending BCL Tickets",
        "Pending Inspection",
        "Pending Decision",
        "Pending Disposition",
        "Pending For Approval"
      ],
      headers: [
        { title: "Tag ID", key: "tag_number", width: '12%', align: "start", sortable: false },
        { title: "Article ID", key: "sku_code", sortable: true },
        { title: "Article Description", key: "item_description", sortable: true },
        { title: "Brand", key: "incident_date", sortable: true },
        { title: "Ageing", key:"disposition_age"},
        { title: "Supplier", key: "damage_type", sortable: true },
      ],
      table_data: [],
      page: 1,
      totalPages: 1,
      totalCount: '',
      pageSize: defaultPageSize,
      pageSizes: defaultPageSizes,
      pending_info_search: '',
      pending_documents: '',
      pending_doc: '',
      rows: [],
      bclTicketNumberDis : false,
      bclTicketDateDis : false,
      inspectionDateDis : false,
      inspectionReportDis : false,
      referenceNumberDis : false,
      brandDecisionDis : false,
      creditNoteDis : false,
      creditNoteAmountDsi : false,
      discountPercentageDis: false,
      discountValueDis : false,
      repairTypeDis : false,
      app_ref_text_dis : false,
      approved_amount: '',
      tag_number: '',
      search: '',
      currentUser: {},
      selectedDisposition: '',
      credit_note_amount_for_auto_population: '',
      claim_amount: '',
      organization_name:'',
      pending_documents_options: [],
      reject_reason: '',
      app_ref_text_dis : false,
      filter_result: [],
      select_field_items: [
      {
                "name":"Tag ID",
                "id": "tag_number"
              },
              {
                "name":"Serial Number",
                "id": "serial_number"
              },
              {
                "name":"IRD Number",
                "id": "ird_number"
              },
              {
                "name":"IRRD Number",
                "id": "irrd_number"
              }
      ],
      select_field:null,
      dialogDetails: {
        title: "Update",
        popup: false,
        width: "",
        type: "Pending Information",
        inputAdd: "ADD DATA FIELD"
      },
      addColoumns: {
        show: false,
        addText: "ADD DATA FIELD",
        deleteTaxt: "DELETE DATA FIELD"
      },
      disposition_item: [],
      disabledSubmitButton: false,
      down_ids:[],
      tab_index : 0,
      filtered_rows : [],
      isFiltering : false,
      mrp_rule: [v => !!v || 'The field is required',
      v => (Number(v) <= Number(this.claim_amount)) || 'Approved amount should be less then claim amount', this.validatePositiveNumber],
    }
  },
  components: {
    HeaderComponent,
    BrandCallLogDialog,
    Loading
  },
  validations: {
    file: { required }
  },
  async created() {
    this.organization_name = this.$store.state.organization_name;
    this.role = this.$store.state.currentUser.roles[0]
    if(this.role in module_that_allowed && moduleAccessFunc(this.role,this.organization_name === 'Voltas' ? 'Chargeback' : 'Brand Call Log')){
      signout()
      return;
    }
    this.action = this.$store.state.action;
    this.headerText = this.organization_name === 'Voltas' ? 'Chargeback' : 'Brand Call Log';
    this.$store.state.action = '';
    this.currentUser = this.$store.state.currentUser;
    const tab = this.$store.state.active_tab
    if(this.action == 'Pending Information' || tab == 'Pending Information'){
      this.tab_index = 0;
      this.loadData('Pending Information');
    } else if(this.action == 'Pending BCL Tickets' || tab ==  'Pending BCL Tickets'){
      this.tab_index = 1;
      this.loadData('Pending BCL Tickets');
    } else if(this.action == 'Pending Inspection' || tab == 'Pending Inspection'){
      this.tab_index = 2;
      this.loadData('Pending Inspection');
    } else if(this.action == 'Pending Decision' || tab == 'Pending Decision'){
      this.tab_index = 3;
      this.loadData('Pending Decision');
    }else  if(this.action == 'Pending Disposition' || tab == 'Pending Disposition'){
      this.tab_index = 4;
      this.loadData('Pending Disposition');
    }else {
      this.tab_index = 0;
      this.loadData('Pending Information');
    }
      this.getFilterDropdownData();
  },
  watch: {
    selected(newVal) {
      if (this.active_tab === 'Pending Information' || this.active_tab === 'Pending BCL Tickets' || this.active_tab === 'Pending Inspection') {
        const putawayInward = newVal.filter(brand_call_logs => brand_call_logs.is_putaway_inwarded === false)
        const isUnderPhysicalInspection = newVal.filter((insurances) => insurances.is_under_physical_inspection === true);
       if(putawayInward.length > 0){
        this.$nextTick(() => {
          this.showAlert("warning", "Please complete Putaway Process");
          this.selected = [];
        });
       }else if(isUnderPhysicalInspection.length > 0) {
             this.$nextTick(() => {
              this.showAlert("warning", "Action on item blocked as it is under cycle count process");
              this.selected = [];
            });
         } 
      }
    }
  },
  computed: {
    isButtonEnabled() {
      if (this.selected.length === 1) return true; 
      if (this.selected.length > 1) {
        const brand = this.selected[0].brand;
        return this.selected.every(item => item.brand === brand); 
      }
      return false; 
    },
    dataTableStyle() {
      return { height: 'calc(var(--vh, 1vh) * 100 - 310px) !important' }          
    },
  },
  methods: {
    isActionAllowed(){
      return !isOnlyViewAction(this.role, this.organization_name === 'Voltas' ? 'Chargeback' : 'Brand Call Log')
    },
    downloadInventory() {
          this.down_ids = this.selected.map(bcl => bcl.id);
          let tab_name
          if(this.active_tab === 'Pending Information'){
            tab_name = 'pending_information'
          }else if(this.active_tab === 'Pending BCL Tickets'){
            tab_name = 'pending_bcl_ticket'
          }else if(this.active_tab === 'Pending Inspection'){
            tab_name = 'pending_inspection'
          }else{
            tab_name = 'pending_decision'
          }
          this.$httpSecured.post("/api/v1/warehouse/brand_call_logs/get_csv_file",
          {
            "ids": this.down_ids,
            "status": tab_name
          })
            .then(response => {
              if(response.data.url){
                const link = document.createElement('a');
                link.href=response.data.url
                link.click()
                this.successmessage = "File downloaded successfully!"
              } else 
                this.successmessage = response.data.message
              this.successPopup(this.successmessage)
            })
            .catch(error => {
                this.showAlert("error", error.response.data.error);
                this.loading = false;
                this.handleClosePopup()
            });
        },
    addMoreRows() {
      let selected_item = this.rows.filter(row => row.element === "select").map(item => item.seletedValue)
      let remaingOPtions = this.pending_documents_options.filter(option => !selected_item.includes(option.field))
      let fill_data = this.rows.filter(row => row.element === "select").map(item => item.value || item.file)
      if (fill_data.includes(undefined) || remaingOPtions.length === 0) {
      } else {
        if (remaingOPtions.length === 1) {
          this.addColoumns.show = false
        }
        this.rows = [
          ...this.rows,
          { element: "select", label: "Select data field", options: remaingOPtions, inputLabel: "Update", inputType: "text", accept: 'application', itemText: "label", itemValue: "field", },
        ];
      }
    },
    deleteRow(index) {
      this.rows.splice(index, 1);
    },

    getRequestParams(page, pageSize) {
      let params = {};

      if (page) {
        params["page"] = page;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      return params;
    },
    showAlert(alert_type, alert_message) {
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.alertTimeOut();
    },
    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },

    async apiCaller({ method = "get", url, headers = {}, pagePage = false, params = {}, body = {} }) {
      let apiArguments = {
        params: { ...params },
        headers
      }
      if (pagePage) {
        const Pageparams = this.getRequestParams(this.page, this.pageSize);
        apiArguments.params = { ...apiArguments.params, page: Pageparams['page'], per_page: Pageparams['size'] }
      }
      if(url!="/api/v1/warehouse/put_away/filters_data" && url!="/api/v2/configuration_settings?name=brand_call_log_reject_reason" && url!="/api/v1/warehouse/brand_call_logs/get_dispositions")
      this.loading = true;
      this.disabledSubmitButton = true
      // let result = await this.$httpSecured[method](url, apiArguments)
      let httpMethod = method === "get" ? this.$httpSecured[method](url, apiArguments) : this.$httpSecured[method](url, body, apiArguments)
      let result = await httpMethod.then((response) => {
        if (response.status === 200 && response.data && response.headers["content-type"] !== "text/html") {
          return { response: true, data: response.data };
        } else {
          this.showAlert("error", "No Data Found");
          return "No Data Found"
        }
      })
        .catch((error) => {
          this.showAlert("error", error.response.data.error ? error.response.data.error : error.response.data.message);
          if(!(this.dialogDetails.dialogType === 'update' && this.dialogDetails.active_tab === 'Pending Information'))
          this.handleClosePopup()
          return error.response.data.error ? error.response.data.error : error.response.data.message
        })
        .finally(() => {
          this.disabledSubmitButton = false
          if(url!="/api/v1/warehouse/put_away/filters_data" && url!="/api/v2/configuration_settings?name=brand_call_log_reject_reason" && url!="/api/v1/warehouse/brand_call_logs/get_dispositions")
            this.loading = false;
        });
      let finallResult = { result: result.response ? result.data : "", error: !result.response ? result : "" }
      return finallResult
    },

    loadData(tab, tab_action) {
      if (tab_action) {
        this.pending_info_search = ''
        this.select_field = null;
      }
      this.isFiltering = false
      this.loading = true;
      this.selected = []
      this.active_tab = tab
      this.table_data = []
      this.page = 1
      this.totalPages = 1
      this.$store.commit('setActiveTab',{
        'active_tab' : tab
      })
      if(tab_action && (tab == 'Pending Inspection' || tab == 'Pending Decision') ){
        var tabName = tab.replace(/\s/g,'_');
        tabName = tabName.split('(').join('');
        tabName = tabName.split(')').join('');
        tabName = tabName.replace(/&/g,'')
        this.$router.push({ name : 'BrandCallLog', query : { Tab : tabName }});
      }else{
        this.$router.push({ name : 'BrandCallLog'});
      }
      if (tab == "Pending Information") {
        (this.headers = [
          { title: "Tag ID", key: "tag_number",minWidth:"200px", align: "start", sortable: false },
          { title: "Article ID", key: "sku_code", sortable: true ,minWidth:"200px" },
          { title: "Article Description", key: "item_description", sortable: true ,minWidth:"200px" },
          { title: "Brand", key: "brand", sortable: true ,minWidth:"200px" },
          { title: "Type Of Item", key: "type_of_item" ,minWidth:"200px"},
          { title: "Sub-Location", key: "sub_location_name",minWidth:"200px"},
          { title: "Ageing", key:"disposition_age"},
          { title: "Vendor", key: "supplier", sortable: true ,minWidth:"200px" },
          { title: "IRRD Number", key: "irrd"},
          { title: "IRD Number", key:"ird"},
          { title: "Serial Number ", key: "serial_number" },
        ]);

        this.fetchPendingInfromation();
      }
      if (tab == 'Pending BCL Tickets') {
        (this.headers = [
          { title: "Tag ID", key: "tag_number" ,minWidth:"200px", align: "start", sortable: false },
          { title: "Article ID", key: "sku_code", sortable: true ,minWidth:"200px" },
          { title: "Article Description", key: "item_description", sortable: true ,minWidth:"200px" },
          { title: "Brand", key: "brand", sortable: true ,minWidth:"200px" },
          { title: "Type Of Item", key: "type_of_item" ,minWidth:"200px"},
          { title: "Sub-Location", key: "sub_location_name",minWidth:"200px"},
          { title: "Ageing", key:"disposition_age"},
          { title: "Vendor", key: "supplier", sortable: true ,minWidth:"200px" },
          { title: "IRRD Number", key: "irrd"},
          { title: "IRD Number", key:"ird"},
          { title: "Serial Number ", key: "serial_number" },
        ]);

        this.fetchPendingBclTicket();
      }
      if (tab == 'Pending Inspection') {
        const ticketHeader = this.$isRelianceClient() ? { title: "Call Log Number", key: "ticket_number" } : { text: "Ticket Number", value: "ticket_number" };
        (this.headers = [
          { title: "Tag ID", key: "tag_number", minWidth:"200px", align: "start", sortable: false },
          { title: "Article ID", key: "sku_code", sortable: true ,minWidth:"200px"},
          { title: "Brand", key: "brand", sortable: true ,minWidth:"200px" },
          { title: "Sub-Location", key: "sub_location_name",minWidth:"200px"},
          { title: "Vendor", key: "supplier", sortable: true ,minWidth:"200px" },
          { title: "Ageing", key:"disposition_age"},
          { title: "Type Of Item", key: "type_of_item" ,minWidth:"200px"},
          { title: "IRRD Number", key: "irrd"},
          { title: "IRD Number", key:"ird"},
          { title: "Serial Number ", key: "serial_number" },
          ticketHeader
        ]);

        this.fetchPendingInspection();
      }
    if (tab == 'Pending Disposition') {
        this.selectedDisposition = '';
        (this.headers = [
          { title: "Tag ID", key: "tag_number", width: '12%', align: "start", sortable: false,minWidth:"200px" },
          { title: "Article ID", key: "sku_code", sortable: true,minWidth:"200px" },
          { title: "Article Description", key: "item_description", sortable: true,minWidth:"200px" },
          { title: "Grade", key: "grade", sortable: true,minWidth:"200px" },
          { title: "Type Of Item", key: "type_of_item",minWidth:"200px"},
          { title: "Sub-Location", key: "sub_location_name",minWidth:"200px"},
          { title: "Benchmark Price (₹)", key: "benchmark_price", sortable: true,minWidth:"200px" },
          { title: "Net Recovery (₹)", key: "net_recovery", sortable: true,minWidth:"200px" },
          { title: "Ageing", key:"disposition_age"},
          { title: "Net Recovery (%)", key: "recovery_percent", sortable: true,minWidth:"200px" },
          { title: "IRRD Number", key: "irrd"},
          { title: "IRD Number", key:"ird"},
          { title: "Serial Number ", key: "serial_number" },
        ]);
        this.fetchPendingDisposition();
        let params = {}
        if (this.currentUser.roles.includes('central_admin')) {
          params = {
            salvage_action: "reject"
          }
        }
        let apiArguments = {
          method: "get",
          url: "/api/v1/warehouse/brand_call_logs/get_dispositions",
          params
        }
        this.getDispositions(apiArguments)

      }
      if (tab == 'Pending Decision') {
        const ticketHeader = this.$isRelianceClient() ? { title: "Call Log Number", key: "ticket_number" } : { text: "Ticket Number", value: "ticket_number" };
        (this.headers = [
          { title: "Tag ID", key: "tag_number" ,minWidth:"200px", align: "start", sortable: false },
          { title: "Article ID", key: "sku_code", sortable: true ,minWidth:"200px" },
          { title: "Brand", key: "brand", sortable: true ,minWidth:"200px" },
          { title: "Type Of Item", key: "type_of_item" ,minWidth:"200px"},
          { title: "Ageing", key:"disposition_age"},
          { title: "Vendor", key: "supplier", sortable: true ,minWidth:"200px"},
          { title: "IRRD Number", key: "irrd"},
          { title: "IRD Number", key:"ird"},
          { title: "Serial Number ", key: "serial_number" },
          ticketHeader
        ]);
        this.fetchPendingDecision();
        if(this.$isRelianceClient()){
          this.getRejectItems();
        }
      }
      if (tab == 'Pending For Approval') {
        this.headers = [
                    { title: "Location", key: "location"},
                    { title: "IRD", key: "ird" },
                    { title: "Tag ID", key: "tag_number" },
                    { title: "Article ID", key: "article_id" },
                    { title: "Article Description", key: "article_description"},
                    { title: "Lot ID", key: "lot_id" },
                    { title: "Publish ID", key: "publish_id"},
                    { title: "Recovery Benchmark Price", key: "recovery_benchmark_price" },
                    { title: "Serial No.1", key: "serial_number" },
                    { title: "Serial No.2", key: "serial_number2"},
                    { title: "Approval Type", key: "approval_rule_type"},
                    { title: "Pending At", key: "next_approver_details"}
                ];
            this.select_field_items = [
                {
                    "name":"Tag ID",
                    "id": "tag_number"
                  },
                  {
                    "name":"IRD",
                    "id": "ird_number"
                  },
                  {
                    "name":"Lot ID",
                    "id": "lot_id"
                  },
                  {
                    "name":"Publish ID",
                    "id": "publish_id"
                  },
                  {
                    "name":"Pending At",
                    "id": "pending_at"
                  }
          ],
        this.fetchPendingAppprData();
      }
    },

    apiFormatData(data) {

      let modifiedData = data.length > 0 ? data.map(item => {
        let modifiedItem = {};
        for (let key in item) {
          if (item[key] === "" || item[key] === null) {
            modifiedItem[key] = "";
          } else {
            modifiedItem[key] = item[key];
          }
        }
        return modifiedItem;
      }) : [];
      return modifiedData
    },

    async fetchPendingInfromation(params = {}) {
      let apiArguments = {
        method: "get",
        url: "/api/v1/warehouse/brand_call_logs/index_new",
        pagePage: true,
        params: {status: "pending_information", ...params }
      }
      if(this.pending_info_search){
        apiArguments.params[this.select_field.id] = this.pending_info_search
      }
      let { result, error } = await this.apiCaller(apiArguments)
      if (!error && result) {
        this.table_data = this.apiFormatData(result.brand_call_logs)
        this.totalPages = result.meta.total_pages
        this.totalCount = result.meta.total_count
      } else {
        this.table_data = []
        this.totalPages = 0
      }
      this.selected = [];
    },

    async fetchPendingBclTicket(params = {}) {

      let apiArguments = {
        method: "get",
        url: "/api/v1/warehouse/brand_call_logs/index_new",
        pagePage: true,
        params: { status: "pending_bcl_ticket", ...params }
      }
      if(this.pending_info_search){
        apiArguments.params[this.select_field.id] = this.pending_info_search
      }
      let { result, error } = await this.apiCaller(apiArguments)

      if (!error && result) {
        this.table_data = this.apiFormatData(result.brand_call_logs)
        this.totalPages = result.meta.total_pages
        this.totalCount = result.meta.total_count
      } else {
        this.table_data = []
        this.totalPages = 0
      }
      this.selected = [];
    },
    async fetchPendingInspection(params = {}) {

      let apiArguments = {
        method: "get",
        url: "/api/v1/warehouse/brand_call_logs/index_new",        
        pagePage: true,
        params: { status: "pending_inspection", ...params }
      }
      if(this.pending_info_search){
        apiArguments.params[this.select_field.id] = this.pending_info_search
      }
      let { result, error } = await this.apiCaller(apiArguments)

      if (!error && result) {
        this.table_data = this.apiFormatData(result.brand_call_logs)
        this.totalPages = result.meta.total_pages
        this.totalCount = result.meta.total_count
      } else {
        this.table_data = []
        this.totalPages = 0
      }
      this.selected = [];
    },
    async fetchPendingDecision(params = {}) {

      let apiArguments = {
        method: "get",
        url: "/api/v1/warehouse/brand_call_logs/index_new",
        pagePage: true,
        params: { status: "pending_decision", ...params }
      }
      if(this.pending_info_search){
        apiArguments.params[this.select_field.id] = this.pending_info_search
      }
      let { result, error } = await this.apiCaller(apiArguments)

      if (!error && result) {
        this.table_data = this.apiFormatData(result.brand_call_logs)
        this.totalPages = result.meta.total_pages
        this.totalCount = result.meta.total_count
      } else {
        this.table_data = []
        this.totalPages = 0
      }
      this.selected = [];
    },
    async fetchPendingAppprData(params = {}) {
      let apiArguments = {
        method: "get",
        url: "/api/v1/warehouse/brand_call_logs/index_new",
        pagePage: true,
        params: { status: "pending_approval", ...params }
      }
      if(this.pending_info_search){
        apiArguments.params[this.select_field.id] = this.pending_info_search
      }
      let { result, error } = await this.apiCaller(apiArguments)

      if (!error && result) {
        this.table_data = this.apiFormatData(result.brand_call_logs)
        this.totalPages = result.meta.total_pages
        this.totalCount = result.meta.total_count
      } else {
        this.table_data = []
        this.totalPages = 0
      }
      this.selected = [];
    },
    async fetchPendingDisposition(params = {}) {

      let apiArguments = {
        method: "get",
        url: "/api/v1/warehouse/brand_call_logs/index_new",
        pagePage: true,
        params: { status: "pending_disposition", ...params }
      }
      if(this.pending_info_search){
        apiArguments.params[this.select_field.id] = this.pending_info_search
      }
      let { result, error } = await this.apiCaller(apiArguments)

      if (!error && result) {
        this.table_data = this.apiFormatData(result.brand_call_logs)
        this.totalPages = result.meta.total_pages
        this.totalCount = result.meta.total_count
      } else {
        this.table_data = []
        this.totalPages = 0
      }
      this.selected = [];
    },
    async getDispositions(apiArguments) {

      let { result, error } = await this.apiCaller(apiArguments)

      if (!error && result) {
        this.disposition_item = result.dispositions;

      } else {
        this.disposition_item = ""
      }
    },

    handlePageChange(value, type) {
      this.page = value;
      if(this.isFiltering){
        this.rows = this.filtered_rows;
        this.applyFilterData()
        return;
      }
      if (this.active_tab == 'Pending Information') {
        this.fetchPendingInfromation();
      } else if (this.active_tab == 'Pending BCL Tickets') {
        this.fetchPendingBclTicket();
      } else if (this.active_tab == 'Pending Inspection') {
        this.fetchPendingInspection();
      } else if (this.active_tab == 'Pending Decision') {
        this.fetchPendingDecision();
      }else if (this.active_tab == 'Pending For Approval') {
        this.fetchPendingAppprData();
      }else {
        this.fetchPendingDisposition();
      }
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      if (this.active_tab == 'Pending Information') {
        this.fetchPendingInfromation();
      } else if (this.active_tab == 'Pending BCL Tickets') {
        this.fetchPendingBclTicket();
      } else if (this.active_tab == 'Pending Inspection') {
        this.fetchPendingInspection();
      } else if (this.active_tab == 'Pending Decision') {
        this.fetchPendingDecision();
      }else if (this.active_tab == 'Pending For Approval') {
        this.fetchPendingAppprData();
      } else {
        this.fetchPendingDisposition();
      }
    },
    getRejectItems(){
      let rejectReasonOptions = [];
      let rejectApiArgs = {
        method: "get",
        url: "/api/v2/configuration_settings?name=brand_call_log_reject_reason"
      };
      this.apiCaller(rejectApiArgs)
      .then(rejectApiResponse => {
        if (rejectApiResponse.result && !rejectApiResponse.error) {
          rejectReasonOptions = rejectApiResponse.result.value;
        }
      })
      .catch(error => {
        console.error("Error fetching reject items:", error);
      });
    },

    async dialogOpen() {
      let ids = this.getSelectedIds()
      let selectedBrand = this.selected.filter((selecteItem, index, selfArray) => {
        let brands = selfArray.map(item => item.brand)
        return brands.indexOf(selecteItem.brand) === index
      })
      let selectedSupplier = this.selected.filter((selecteItem, index, selfArray) => {
        let brands = selfArray.map(item => item.supplier)
        return brands.indexOf(selecteItem.supplier) === index
      })

      if (ids.length > 0) {
        let tabs = ['Pending Information', 'Pending BCL Tickets', 'Pending Inspection', 'Pending Decision']

        if (tabs.includes(this.active_tab)) {
          if (selectedBrand.length > 1 || selectedSupplier.length > 1) {
            this.showAlert("error", "Please select same brands and suppliers");
          } else {
            if (this.active_tab === "Pending Information") {
              this.updatePendingInformationfieldData()
            } else if (this.active_tab === 'Pending Decision') {
              let apiArguments = {
                method: "get",
                url: "/api/v1/warehouse/brand_call_logs/get_brand_decisions"
              }
              let { result, error } = await this.apiCaller(apiArguments)
              if (result && !error) {
                let brandDecisionOptions = ids.length > 1 ? result.brand_decisions.filter(item => item.id !== "Discount") : result.brand_decisions
                let repairTYpeLocation = result.locations
                let purchasePrice =  selectedBrand[0].benchmark_price || 0
                this.updatePopupDisability()

                let rejectReasonOptions = [];
                let rejectApiArgs = {
                  method: "get",
                  url: "/api/v2/configuration_settings?name=brand_call_log_reject_reason"
                };
                this.apiCaller(rejectApiArgs)
                .then(rejectApiResponse => {
                  if (rejectApiResponse.result && !rejectApiResponse.error) {
                    rejectReasonOptions = rejectApiResponse.result.value;
                    this.dialogDetails = {
                      title: "Update",
                      popup: true,
                      width: "",
                      active_tab: this.active_tab,
                      dialogType: "update",
                      closeBtn: true,
                      submitBtn: true,
                      closeText: "Cancel",
                      submitText: "Submit",
                      brandDecisionDis:this.brandDecisionDis,
                      referenceNumberDis: this.referenceNumberDis,
                      creditNoteDis: this.creditNoteDis,
                      creditNoteAmountDsi : this.creditNoteAmountDsi,
                      discountPercentageDis : this.discountPercentageDis,
                      discountValueDis : this.discountValueDis,
                      repairTypeDis : this.repairTypeDis,
                      app_ref_text_dis : this.app_ref_text_dis,
                      app_ref_text_dis : this.app_ref_text_dis,
                      fieldData: {
                        brand_approval_number_value: ids.length == 1 && this.selected[0].approval_ref_number && this.selected[0].approval_ref_number != 'N/A' ? this.selected[0].approval_ref_number : '',
                        show_discount_in_vendor_amount: ids.length == 1 && this.selected[0].show_discount_in_vendor_amount,
                        approval_reference_text: ids.length == 1 && this.selected[0].approval_reference_text && this.selected[0].approval_reference_text != 'N/A' ? this.selected[0].approval_reference_text : '',
                        brand_approval_attachment : null,
                        brand_decision_options: brandDecisionOptions,
                        repair_type_location_options : repairTYpeLocation ? repairTYpeLocation : null,
                        brand_decision_value: ids.length == 1 && this.selected[0].brand_decision && this.selected[0].brand_decision != 'N/A' ? this.selected[0].brand_decision : null,
                        benchmark_price : purchasePrice,
                        discount_percentage: (ids.length == 1 && this.selected[0].discount_percentage && this.selected[0].discount_percentage != 'N/A') ? this.selected[0].discount_percentage : 
                                            (ids.length == 1 && this.selected[0].benchmark_price && this.selected[0].discount_value && this.selected[0].discount_value != 'N/A') ? Math.round((this.selected[0].discount_value * 100)/this.selected[0].benchmark_price) : '',
                        credit_note_number: ids.length == 1 && this.selected[0].credit_note_number && this.selected[0].credit_note_number != 'N/A' ? this.selected[0].credit_note_number : '',
                        discount_value: ( ids.length == 1 && this.selected[0].discount_value && this.selected[0].discount_value != 'N/A') ? this.selected[0].discount_value :
                                        ( ids.length == 1 && this.selected[0].benchmark_price && this.selected[0].discount_percentage && this.selected[0].discount_percentage != 'N/A') ? Math.round((this.selected[0].discount_percentage * this.selected[0].benchmark_price)/100) : '',
                        credit_note_amount : !this.$isRelianceClient() ? ids.length == 1 && this.selected[0].purchase_price && this.selected[0].purchase_price != 'N/A' ? this.selected[0].purchase_price : '' :
                                              ids.length == 1 && this.selected[0].purchase_price && this.selected[0].purchase_price != 'N/A' ? this.selected[0].purchase_price : '' ,
                        repair_type_location_value : ids.length == 1 && this.selected[0].repair_type && this.selected[0].repair_type != 'N/A' ? this.selected[0].repair_type : null,
                        reject_reason_options: rejectReasonOptions
                      }
                    }
                  }
                })
                .catch(error => {
                  console.error("Error fetching reject items:", error);
                });

              }
            } else {
              this.addColoumns.show = false;
              this.setdialogRows('update')
              this.dialogDetails = {
                title: "Update",
                popup: true,
                width: "",
                active_tab: this.active_tab,
                dialogType: "update",
                closeBtn: true,
                submitBtn: true,
                closeText: "Cancel",
                submitText: "Submit",
              }
            }
          }
        } else {
          this.addColoumns.show = false;
          this.setdialogRows('update')
          this.dialogDetails = {
            title: "Update",
            popup: true,
            width: "",
            active_tab: this.active_tab,
            dialogType: "update",
            closeBtn: true,
            submitBtn: true,
            closeText: "Cancel",
            submitText: "Submit",
          }
        }
      } else {
        this.showAlert("error", "Please select a tag id");
      }

    },

    filtersData() {
      document.documentElement.style.setProperty('--dialog-ypos', (this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 40).toString() + 'px');
      this.addColoumns.show = false;
      let data = {
        itemText: "key",
        itemValue: "value",
        brandsOptions: this.filter_result.brands,
        putaway_status:["Pending", "Completed"],
        item_options:[
          {
              "key": "HD",
              "value": "HD"
          },
          {
              "key": "G&G",
              "value": "G&G"
          }
        ],
        gradeOptions: this.filter_result?.grades?.map(grade => {
          return ({ label: grade.key, inputTag: "checkBox", ...grade, value: false })
        })
      }
      var filter_width = "900px"
      if(window.innerWidth > 1400 && window.innerWidth < 1500)
        filter_width = "1050px"
      else if(window.innerWidth >= 1500 && window.innerWidth < 1600)
        filter_width = "1150px"
      else if(window.innerWidth >= 1600)
        filter_width = "1250px"
      this.setdialogRows('filter', data)
      this.dialogDetails = {
        popup: true,
        type: this.active_tab,
        highestColums: 3,
        dialogType: "filter",
        closeBtn: true,
        submitBtn: true,
        closeText: "Cancel",
        submitText: "Apply Filter(s)",
        width: filter_width
      }
    },
    async getFilterDropdownData(){
      // this.isFullpageLoading = true
      let apiArguments = {
        method: "get",
        url: "/api/v1/warehouse/put_away/filters_data"
      }
      let { result, error } = await this.apiCaller(apiArguments)
      if (result && !error) {
        this.filter_result = result;
      }
      if(result || error){
        this.isFullpageLoading = false
      }
    },
    async handleDisposition(type, item) {
      let ids = this.getSelectedIds()
      if (ids.length == 0) {
        this.showAlert("error", "Please select at least one record !")
        return "Please select at least one record !"
      }
      let body;
      if (type === "approve") {
        body = { ids: ids }
      } else if (type === "reject") {
        let data = {
          type: "reject",
          options: this.disposition_item
        }
        this.setdialogRows("update", data)
        this.dialogDetails = {
          popup: true,
          title: "Reject",
          active_tab: this.active_tab,
          dialogType: "update",
          closeBtn: true,
          submitBtn: true,
          closeText: "Cancel",
          submitText: "Submit",
          width: "300px"
        }
        // body = {
        //   ids: ids,
        //   disposition_action: "reject",
        //   disposition: "Replacement"
        // }
      } else if (type === "assignDisposition") {
        body = {
          ids: ids,
          disposition: item.id
        }
      }
      if (body) {

        let apiArguments = {
          method: "post",
          url: ['approve', 'reject'].includes(type) ? "/api/v1/warehouse/brand_call_logs/set_disposition" : "/api/v1/warehouse/brand_call_logs/update_disposition",
          body
        }

        let { result, error } = await this.apiCaller(apiArguments)
        if (result && !error) {
          this.successPopup(result.message)
        }
      }

    },

    handleClosePopup() {
      this.rows = []
      this.dialogDetails = {
        popup: false
      }
      this.addColoumns.show = false;
    },

    async updatePendingInformationfieldData() {
      let ids = this.getSelectedIds().join(',')
      let apiArguments = {
        method: "get",
        url: "/api/v1/warehouse/brand_call_logs/get_pending_documents",
        params: { ids }
      }
      let { result, error } = await this.apiCaller(apiArguments)

      if (result && !error) {
        if (this.$isRelianceClient()) {
          result.pending_documents = result.pending_documents.map(doc => {
            if (doc.label === "Purchase Vendor") {
              doc.label = "Vendor";
            }else if (doc.label === "Purchase Location") {
              doc.label = "Receiving DC";
            }
            return doc;
          });
        }
        this.addColoumns.show = result.pending_documents.length > 1 ? true : false;
        // result.pending_documents.push(
        //   {
        //     "field": "purchase_invoice_date",
        //     "label": "Purchase Date",
        //     "data_type": "date",
        //     "is_mandatory": true
        // },
        // )
        this.pending_documents_options = result.pending_documents
        result = await this.ItemInfoDetails(result);
        this.setdialogRows('update', result.pending_documents)
        this.dialogDetails = {
          title: "Update",
          popup: true,
          width: "",
          active_tab: this.active_tab,
          highestColums: 3,
          dialogType: "update",
          closeBtn: true,
          submitBtn: true,
          closeText: "Cancel",
          submitText: "Submit",
        }
      }
    },
    async ItemInfoDetails(attr){
      let apiArguments = {
        method: "get",
        url: `/api/v1/warehouse/brand_call_logs/${this.selected[0].id}/get_update_details`
      }
      let { result, error } = await this.apiCaller(apiArguments)
      if (result && !error) {
        attr.pending_documents.forEach(item => {
          if(result.data[item.label])
            item.original_data = result.data[item.label]
          else item.original_data = ''
        })
      }
      return attr;
    },
    handlePopupLinkClick(data, value) {
      if(this.putaway_process === false){
         this.$toast.error("Please complete Putaway Process");
      }else{
        this.setdialogRows("popupLink", value)
        this.dialogDetails = {
         popup: true,
        title: "Update",
        // active_tab: this.active_tab,
        dialogType: "update",
        popupLink: true,
        closeBtn: true,
        submitBtn: true,
        closeText: "Cancel",
        submitText: "Submit",
        width: ""
      }
      }
    },
    updatePopupDisability() {
      this.bclTicketNumberDis = false;
      this.bclTicketDateDis = false;
      this.inspectionDateDis = false;
      this.inspectionReportDis = false;
      this.referenceNumberDis = false;
      this.brandDecisionDis = false;
      this.creditNoteDis = false;
      this.creditNoteAmountDsi = false;
      this.discountPercentageDis = false;
      this.discountValueDis = false;
      this.repairTypeDis = false;
      this.app_ref_text_dis = false;
      
      this.selected.forEach(item => {
        if (item.ticket_number && item.ticket_number !== 'N/A') this.bclTicketNumberDis = true;
        if (item.ticket_date && item.ticket_date !== 'N/A') this.bclTicketDateDis = true;
        if (item.inspection_date && item.inspection_date !== 'N/A') this.inspectionDateDis = true;
        if (item.inspection_report && item.inspection_report !== 'N/A') this.inspectionReportDis = true;
        if (item.approval_ref_number && item.approval_ref_number !== 'N/A') this.referenceNumberDis = true;
        if (item.credit_note_number && item.credit_note_number !== 'N/A') this.creditNoteDis = true;
        if (item.brand_decision && item.brand_decision !== 'N/A') this.brandDecisionDis = true;
        // if (item.credit_note_amount && item.credit_note_amount !== 'N/A') this.creditNoteAmountDsi = true;          
        if (item.discount_percentage && item.discount_percentage !== 'N/A') this.discountPercentageDis = true;
        if (item.discount_value && item.discount_value !== 'N/A') this.discountValueDis = true;
        if (item.repair_type && item.repair_type !== 'N/A') this.repairTypeDis = true;
        if (item.approval_reference_text && item.approval_reference_text !== 'N/A') this.app_ref_text_dis = true;
      });
    },
    setdialogRows(type, data) {
      let rows;
      const ids = this.selected.map(brandCallLog => brandCallLog.id)
      if (type === 'filter') {
        if (this.active_tab === 'Pending Information' || this.active_tab === 'Pending BCL Tickets') {
          rows = [
            { element: "search", label: "Article ID", value: '' },
            { element: "select&search", label: "Brand", value: null, options: data.brandsOptions, multiple: true, itemText: data.itemText, itemValue: data.itemValue },
            { element: "search", label: "Supplier", value: '' },
            { element: "select&search", label: "Putaway Status", value: null, options: data.putaway_status  },
          ];
          if(this.$isRelianceClient()){
            rows.push({ element: "select&search", label: "Type Of Item", value: null, options: data.item_options, itemText: data.itemText, itemValue: data.itemValue, multiple: true});
          }
        } else if (this.active_tab === 'Pending Inspection' || this.active_tab === 'Pending Decision') {
          rows = [
            { element: "search", label: "Article ID", value: '' },
            { element: "select&search", label: "Brand", value: null, options: data.brandsOptions, multiple: true, itemText: data.itemText, itemValue: data.itemValue },
            { element: "search", label: "Supplier", value: '' },
            { element: "search", label: "Brand Call Log Ticket No.", value: '' },
            { element: "select&search", label: "Putaway Status", value: null, options: data.putaway_status  },
          ];
          if(this.$isRelianceClient()){
            rows.push({ element: "select&search", label: "Type Of Item", value: null, options: data.item_options, itemText: data.itemText, itemValue: data.itemValue, multiple: true});
          }
        } else if (this.active_tab === 'Pending Disposition') {
          rows = [
            {
              element: "dropdownwithaction", label: "Grade", menuItems: data.gradeOptions, nestedDialog: false
            },
            {
              element: "dropdownwithaction", label: "Benchmark Price(₹)", title: "Benchmark Price", menuItems: [{ label: "Min", inputLabel: "Enter Price", inputTag: "number", value: "" },
              { label: "Max", inputLabel: "Enter Price", inputTag: "number", value: "" }
              ], nestedDialog: false
            },
            {
              element: "dropdownwithaction", label: "Net Recovery(₹)", title: "Net Recovery",
              menuItems: [{ label: "Min", inputLabel: "Enter Price", inputTag: "number", value: "" },
              { label: "Max", inputLabel: "Enter Price", inputTag: "number", value: "" }
              ]
              , nestedDialog: false
            },
            {
              element: "dropdownwithaction", label: "Net Recovery(%)", title: "Net Recovery %",
              menuItems: [{ label: "Min", inputLabel: "Enter Price", inputTag: "number", value: "" },
              { label: "Max", inputLabel: "Enter Price", inputTag: "number", value: "" }
              ]
              , nestedDialog: false
            },
            { element: "select&search", label: "Putaway Status", value: null, options: data.putaway_status  },
          ];
          if(this.$isRelianceClient()){
            rows.push({ element: "select&search", label: "Type Of Item", value: null, options: data.item_options, itemText: data.itemText, itemValue: data.itemValue, multiple: true});
          } 
        }
      } else if (type === 'update') {
        this.updatePopupDisability();
        if (this.active_tab === 'Pending Information') {
          rows =
            [
              { element: "select", label: "Select data field", options: data, itemText: "label", itemValue: "field", inputLabel: "Update", inputType: "text", accept: 'application' },
              // { element: "file", label: "Update/Upload", accept: 'application/pdf' }
            ]
        } else if (this.active_tab === 'Pending BCL Tickets') {
          rows =
            [
              { element: "alphanumeric", label: "Ticket No.", key: "ticket_number", disablity : this.bclTicketNumberDis, value : ids.length == 1 && this.selected[0].ticket_number && this.selected[0].ticket_number != 'N/A' ? this.selected[0].ticket_number : '' },
              { element: "date", label: "Ticket Date", key: "ticket_date", datePopup: false, max: new Date().toISOString().substr(0, 10), disablity : this.bclTicketDateDis, value : ids.length == 1 && this.selected[0].ticket_date && this.selected[0].ticket_date != 'N/A' ? this.selected[0].ticket_date.split('/').reverse().join('/') : '',isDatePickerClaimTicketDate: new Date() }
            ]
        } else if (this.active_tab === 'Pending Inspection') {
          var report = ''
          var actual_report = null
          if(ids.length == 1 && this.selected[0].inspection_report && this.selected[0].inspection_report != 'N/A'){
            const parts = this.selected[0].inspection_report.split('/').reverse()
            report = {}
            report.name = parts[0]
            actual_report = this.selected[0].inspection_report
          }
          rows =
            [
              { element: "date", label: "Brand Inspection Date", key: "inspection_date", datePopup: false, max: new Date().toISOString().substr(0, 10), disablity : this.inspectionDateDis, value : ids.length == 1 && this.selected[0].inspection_date && this.selected[0].inspection_date != 'N/A' ? this.selected[0].inspection_date.split('/').reverse().join('/') : '',isDatePickerClaimTicketDate: new Date() },
              { element: "file", label: "Brand Inspection Report", accept: '.pdf, .jpg, .jpeg, .png', key: "inspection_report", disablity : this.inspectionReportDis, file : report ? report : '', actual_report : actual_report  }
            ]
        } else if (this.active_tab === 'Pending Decision') {
          rows =
            [
              { element: "text", label: "Brand Approval Reference number", disablity : this.referenceNumberDis },
              { element: "select", label: "Brand Decision", options: ["RTV", "Replacement", "Discount", "Repair", "Reject"], disablity : this.brandDecisionDis },
              { element: "text", label: "Credit Note Number (Optional)", disablity : this.creditNoteDis }
            ]
        }
        else if (this.active_tab === 'Pending Disposition') {
          if (data.type === "reject") {
            rows =
              [
                { element: "select", label: "Disposition", options: data.options, itemText: "id", itemValue: "code", col: '12' },
              ]
          }

        }
      } else if (type === "popupLink") {
        let tag = {}
        if (data.data_type === "doc" || data.data_type === "video" || data.data_type === "image") {
          tag = { element: "file", accept: 'application', label: "Update", key: "file",  variant:"underlined" }
          if(data.data_type === "video"){
            tag.accept = "video/mp4, video/x-m4v"
          }
        } else if(data.data_type === "date"){
          tag= { element: "date", label: "Update", key: "value",isDatePickerClaimTicketDate: new Date() }
        } else {
          tag = { element: "text", label: "Update", key: "value" }
        }
        rows =
          [
            { element: "text", label: "Label Name", key: "label", value: data.label, readonly: true, field: data.field, data_type: data.data_type, is_mandatory: data.is_mandatory },
            { ...tag }
          ]
      } else if (type === "details") {
        rows = data
      }

      this.rows = rows
    },

    dataFormater(data) {
      let required_documents = [];
      if (data.brand_call_log.required_documents) {
        required_documents = data.brand_call_log.required_documents.map((document) => {
          return ({ key: document.label, link: true, ...document })
        })
      }
      let TabThreeAndFour = ["Pending Inspection", 'Pending Decision', 'Pending Disposition']
      let tabData = []
      if (TabThreeAndFour.includes(this.active_tab)) {
        let tab_pending_disposition = []
        if (this.active_tab === 'Pending Disposition') {
          tab_pending_disposition = [
            { key: "Benchmark Price", value: data.brand_call_log.benchmark_price || "N/A" },
            { key: "Net Recovery", value: data.brand_call_log.net_recovery || "N/A" },
            { key: "Net Recovery %", value: data.brand_call_log.recovery_percent.toFixed(1) || "N/A" },
          ]
        }
        tabData = [
          { key: "Brand Call Log Ticket Date", value: data.brand_call_log.ticket_date || "N/A" },
          { key: "Brand Call Log Ticket Number", value: data.brand_call_log.ticket_number || "N/A" },
          { key: "Inspection Date", value: data.brand_call_log.inspection_date || "N/A" },
          ...tab_pending_disposition
        ]
      }

      return ([
        { key: "Article ID", value: data.brand_call_log.sku_code || "N/A" },
        { key: "Article Description", value: data.brand_call_log.item_description || "N/A" },
        { key: "Brand", value: data.brand_call_log.brand || "N/A" },
        // { key: "Supplier", value: data.brand_call_log.supplier || "N/A" },
        ...required_documents,
        ...tabData
      ])

    },

    async itemDetailpopup(item) {
      this.putaway_process = item.is_putaway_inwarded
      this.addColoumns.show = false;
      this.selected_item = item

      let apiArguments = {
        method: "get",
        url: `api/v1/warehouse/brand_call_logs/${item.id}`
      }
      let { result, error } = await this.apiCaller(apiArguments)
          if (result && !error) {
                if (this.$isRelianceClient()) {
              result.brand_call_log.required_documents = result.brand_call_log.required_documents.map(doc => {
                if (doc.label === "Purchase Vendor") {
                  doc.label = "Vendor";
                } else if (doc.label === "Purchase Location") {
                  doc.label = "Receiving DC";
                }
                return doc;
              });
            }

        // if (this.active_tab === 'Pending Information') {
        let data = this.dataFormater(result, this.active_tab)
        this.setdialogRows('details', data)
        this.dialogDetails = {
          title: `Tag ID: ${result.brand_call_log.tag_number}`,
          popup: true,
          width: "700px",
          active_tab: this.active_tab,
          highestColums: 3,
          dialogType: "details",
          data: item
        }
      }
    },

    handleSubmit() {
      if (this.dialogDetails.dialogType === "successAndError") {
        this.handleClosePopup()
        this.selected = []
        this.loadData(this.active_tab)
      } else if (this.dialogDetails.dialogType === 'filter') {
        this.applyFilterData()
      } else {
        if (this.active_tab === 'Pending Information') {
          if (this.dialogDetails.popupLink) {
            let files = this.rows.find(row => row.key === "file")
            let file = files && files.file
            const formData = new FormData();
            if (file) {
              formData.append('field', this.rows.find(row => row.key === "label").field);
              formData.append('label', this.rows.find(row => row.key === "label").value);
              formData.append('data_type', this.rows.find(row => row.key === "label").data_type);
              formData.append('file', file);
            } else {
              formData.append('field', this.rows.find(row => row.key === "label").field);
              if (this.$isRelianceClient()) {
                if (this.rows.find(row => row.key === "label").value === "Vendor") {
                  formData.append('label', 'Purchase Vendor');
                } else if (this.rows.find(row => row.key === "label").value === "Receiving DC") {
                  formData.append('label', 'Purchase Location');
                } else formData.append('label', this.rows.find(row => row.key === "label").value);
              } else
              formData.append('label', this.rows.find(row => row.key === "label").value);
              formData.append('data_type', this.rows.find(row => row.key === "label").data_type);
              formData.append('value', this.rows.find(row => row.key === "value").value);
            }
            this.updateSingleInformationDocument(formData)
          } else {
            let documents = this.rows.map(row => {            
              if (this.$isRelianceClient()) {
                if (row.optionData.label === "Vendor") {
                  row.optionData.label = "Purchase Vendor";
                } else if (row.optionData.label === "Receiving DC") {
                  row.optionData.label = "Purchase Location";
                }
              }
              return ({
                field: row.optionData.field,
                label: row.optionData.label,
                data_type: row.optionData.data_type,
                file: row.file ? row.file : "",
                value: row.value ? row.value : "",
                original_data : row.original_data ? row.original_data : ""
              })
            })

            let formData = new FormData();
            formData.append("ids", this.getSelectedIds());

            documents.forEach((item, index) => {
              if(!item.original_data)
                for (let key in item) {
                  // let fieldName = `documents[${index}][${key}]`;
                  let fieldName = `${key}[${index}]`
                  if(key != 'original_data')
                    formData.append(fieldName, item[key]);
                }
            });

            this.bulkUpdateInformationDocument(formData)
          }
        }
        else if (this.active_tab === 'Pending BCL Tickets') {
          let bodyData = {
            ids: this.getSelectedIds(),
            ticket_date: this.rows.find(row => row.key === "ticket_date").value,
            ticket_number: this.rows.find(row => row.key === "ticket_number").value
          }
          this.updateBLCTicket(bodyData)
        } else if (this.active_tab === "Pending Inspection") {
          const file = this.rows.find(row => row.key === "inspection_report").file;
          const formData = new FormData();
          formData.append('ids', this.getSelectedIds());
          formData.append('inspection_date', this.rows.find(row => row.key === "inspection_date").value);
          if(file)
            formData.append('inspection_report', file);
          else 
            formData.append('inspection_report', this.rows.find(row => row.key === "inspection_report").actual_report);
          this.updatePendingInspection(formData)
        } else if (this.active_tab === 'Pending Decision') {
          let brandDecision = this.dialogDetails.fieldData.brand_decision_value
          let bodyData = {
            ids: this.getSelectedIds(),
            brand_decision: brandDecision,
            approval_ref_number: this.dialogDetails.fieldData.brand_approval_number_value,
            credit_note_number: this.dialogDetails.fieldData.credit_note_number,
            approval_reference_text: this.dialogDetails.fieldData.approval_reference_text,
          }
          if (brandDecision === "RTV") {
            bodyData = {
              ...bodyData,
              credit_note_amount: this.dialogDetails.fieldData.credit_note_amount,
            }
          }else if(brandDecision === 'Repair'){
            let repair_type = this.dialogDetails.fieldData.repair_type_location_value.name || ""
            bodyData = {
              ...bodyData,
              repair_type,
            }
          }
          else if (brandDecision === "Discount") {
            bodyData = {
              ...bodyData,
              discount_percentage: this.dialogDetails.fieldData.discount_percentage,
              credit_note_amount: this.dialogDetails.fieldData.show_discount_in_vendor_amount ? this.dialogDetails.fieldData.discount_value : this.dialogDetails.fieldData.credit_note_amount,
              credit_note_number : ""
            }
          } else if (brandDecision === "Reject") {
            bodyData = {
              ...bodyData,
              credit_note_number: "",
              approval_ref_number : "",
              reject_reason: this.dialogDetails.fieldData.reject_reason
            }
          }
          // this.updatePendingDecision(JSON.stringify(bodyData))
          const formData = new FormData();
          for(let key in bodyData)
            formData.append(key,bodyData[key])
          formData.append('brand_approval_attachment',this.dialogDetails.fieldData.brand_approval_attachment)
          this.updatePendingDecision(formData)
        } else if (this.active_tab === 'Pending Disposition') {
          this.rejectDisposition()
        }
      }
    },

    async rejectDisposition() {
      let apiArguments = {
        method: "post",
        url: "/api/v1/warehouse/brand_call_logs/set_disposition",
        body: {
          ids: this.getSelectedIds(),
          disposition_action: "reject",
          disposition: this.rows.find(row => row.label === "Disposition").value
        }
      }
      let { result, error } = await this.apiCaller(apiArguments)
      if (result && !error) {
        this.successPopup(result.message)
      }
    },
    applyFilterData() {
      if(!this.isFiltering){
        this.page = 1
        this.isFiltering = true
      } 
      this.filtered_rows = this.rows;
      if (this.active_tab !== 'Pending Disposition') {
        let sku_code = this.rows.find(item => ["Article", "Article ID"].includes(item.label)).value
        let supplier = this.rows.find(item => item.label === "Supplier").value
        let brand = this.rows.find(item => item.label === "Brand").value
        let putaway = this.rows.find(item => item.label === "Putaway Status").value
        let ticket_number = this.rows.find(item => item.label === "Brand Call Log Ticket No.")
        if (this.$isRelianceClient()) {
          var type_of_item = this.rows.find(item => item.label === "Type Of Item").value
        }
        if (this.active_tab === 'Pending BCL Tickets') {
          let params = { sku_code, supplier, brand, putaway }
          if(this.$isRelianceClient()){
            params = {...params, type_of_item}
          }
          this.fetchPendingBclTicket(params);
        } else if (this.active_tab === 'Pending Inspection') {
          let params = { sku_code, supplier, brand, putaway, ticket_number: ticket_number && ticket_number.value || "" }
          if(this.$isRelianceClient()){
            params = {...params, type_of_item}
          }
          this.fetchPendingInspection(params)
        } else if (this.active_tab === 'Pending Decision') {
          let params = { sku_code, supplier, brand, putaway, ticket_number: ticket_number && ticket_number.value || "" }
          if(this.$isRelianceClient()){
           params = {...params, type_of_item}
          }
          this.fetchPendingDecision(params)
        } else {
          let params = { sku_code, supplier, brand, putaway}
          if(this.$isRelianceClient()){
            params = {...params, type_of_item}
          }
          this.fetchPendingInfromation(params)
        }
      } else if (this.active_tab === 'Pending Disposition') {

        let grade = this.rows.find(row => (row.label === "Grade")).menuItems.filter(item => item.value).map(item => item.value)
        let min_benchmark_price = this.rows.find(row => (row.label === "Benchmark Price(₹)")).menuItems.find(item => item.label === "Min").value
        let max_benchmark_price = this.rows.find(row => (row.label === "Benchmark Price(₹)")).menuItems.find(item => item.label === "Max").value
        let min_net_recovery = this.rows.find(row => (row.label === "Net Recovery(₹)")).menuItems.find(item => item.label === "Min").value
        let max_net_recovery = this.rows.find(row => (row.label === "Net Recovery(₹)")).menuItems.find(item => item.label === "Max").value
        let min_net_recovery_percent = this.rows.find(row => (row.label === "Net Recovery(%)")).menuItems.find(item => item.label === "Min").value
        let max_net_recovery_percent = this.rows.find(row => (row.label === "Net Recovery(%)")).menuItems.find(item => item.label === "Max").value
        let putaway = this.rows.find(item => item.label === "Putaway Status").value
        let params = {
          grade,
          min_benchmark_price,
          max_benchmark_price,
          min_net_recovery,
          max_net_recovery,
          min_net_recovery_percent,
          max_net_recovery_percent,
          putaway
        }
        if(this.$isRelianceClient()){
          params = {...params, type_of_item}
        }
        this.fetchPendingDisposition(params)
      }

      setTimeout(() => {
        this.handleClosePopup()
      }, 10)
    },
    async bulkUpdateInformationDocument(bodyData) {
      let apiArguments = {
        method: "post",
        url: `/api/v1/warehouse/brand_call_logs/bulk_update_docs`,
        body: bodyData,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }

      let { result, error } = await this.apiCaller(apiArguments)

      if (result && !error) {
        this.successPopup(result.message)
      }
    },
    async updateSingleInformationDocument(bodyData) {
      let apiArguments = {
        method: "put",
        url: `/api/v1/warehouse/brand_call_logs/${this.selected_item.id}/update_document`,
        body: bodyData,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }

      let { result, error } = await this.apiCaller(apiArguments)
      if (result && !error) {
        this.successPopup(result.message)
      }
    },
    getSelectedIds() {
      return this.selected.map(brandCallLog => brandCallLog.id);
    },

    async updateBLCTicket(body) {
      let apiArguments = {
        method: "put",
        url: "/api/v1/warehouse/brand_call_logs/update_ticket",
        body: body
      }
      let { result, error } = await this.apiCaller(apiArguments)
      if (result && !error) {
        this.successPopup(result.message)
      }
    },

    async updatePendingInspection(bodyData) {
      let apiArguments = {
        method: "put",
        url: "/api/v1/warehouse/brand_call_logs/update_inspection_details",
        body: bodyData,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      let { result, error } = await this.apiCaller(apiArguments)
      if (result && !error) {
        this.successPopup(result.message)
      }
    },
    async updatePendingDecision(bodyData) {
      let apiArguments = {
        method: "put",
        url: "/api/v1/warehouse/brand_call_logs/update_approval_details",
        body: bodyData,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      let { result, error } = await this.apiCaller(apiArguments)
      if (result && !error) {
        this.successPopup(result.message)
      }
    },

    successPopup(message) {
      this.addColoumns.show = false;
      this.dialogDetails = {
        popup: true,
        width: "500px",
        dialogType: "successAndError",
        submitBtn: true,
        message: message,
        submitText: "Ok",
      }
    },
    navigateToFileUpload(){
      let tab_name
        // if(this.active_tab === 'Pending Information'){
        //   tab_name = 'pending_information'
        // }else if(this.active_tab === 'Pending BCL Tickets'){
        //   tab_name = 'pending_bcl_ticket'
        // }else if(this.active_tab === 'Pending Inspection'){
        //   tab_name = 'pending_inspection'
        // }else{
        //   tab_name = 'pending_decision'
        // }
      this.$store.commit("setLotIds", {
        lotIds: 'brand_call_log',
        action:this.active_tab,
        inventoryId: 'Brand Call Log'
      });
      this.$store.commit("config/ADD_HEADER", this.headerText);
      this.$router.push({ name: 'LotFileuploadComm' });
    }
  }
}
</script>
<style>
  @import "./BrandCallLogStyle.scss";

  .custom-control_outlined button {
    min-height: 52px;
  }
  @media (max-height: 1104px) {
    .PaddingItemPerPage{
      padding: 8px !important;
    }
  }
  @media (min-height: 1126px) {
    .PaddingItemPerPage{
      padding: 24px !important;
    }
  }
</style>


